import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Admin() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [cfg, setCfg] = useState(null);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (!loading && (!user || user.role !== "admin")) nav("/");
  }, [loading, user, nav]);

  useEffect(() => {
    if (user?.role === "admin") {
      api.get("/admin/config").then(r => { setCfg(r.data); setText(JSON.stringify(r.data, null, 2)); });
      api.get("/admin/users").then(r => setUsers(r.data));
    }
  }, [user]);

  const save = async () => {
    setSaving(true);
    try {
      const parsed = JSON.parse(text);
      await api.put("/admin/config", { data: parsed });
      setCfg(parsed); toast.success("Configuration saved");
    } catch (e) { toast.error("Invalid JSON or save failed"); }
    setSaving(false);
  };

  if (!cfg) return null;
  return (
    <>
      <Nav />
      <main className="container-hs py-10 md:py-14">
        <h1 className="font-display text-3xl mb-2">Admin Configuration</h1>
        <p className="text-sm text-brand-muted mb-6">Edit Home Cost Path defaults, VA funding-fee tables, score thresholds, feature flags, and disclaimer wording.</p>

        <div className="card-hs p-4 sm:p-6 mb-8">
          <textarea data-testid="admin-config-json" className="hs-input font-mono text-xs min-h-[420px]" value={text} onChange={e => setText(e.target.value)} />
          <div className="flex justify-end mt-4">
            <button data-testid="admin-save" onClick={save} disabled={saving} className="btn-primary">{saving ? "Saving…" : "Save Configuration"}</button>
          </div>
        </div>

        <div className="card-hs p-6">
          <h2 className="font-display text-xl mb-4">Users ({users.length})</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-brand-soft/50 text-brand-muted">
                <tr><th className="text-left p-3">Email</th><th className="text-left p-3">Name</th><th className="text-left p-3">Role</th><th className="text-left p-3">Provider</th></tr>
              </thead>
              <tbody>
                {users.map(u => (
                  <tr key={u.user_id} className="border-t border-brand-border">
                    <td className="p-3">{u.email}</td><td className="p-3">{u.name}</td>
                    <td className="p-3">{u.role}</td><td className="p-3">{u.auth_provider}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
